module.exports = __webpack_public_path__ + "img/magento-custom-development_medium@2x.71312ade.webp";